import styled from 'styled-components'
import { animated } from '@react-spring/web'
import { SectionCircleLoader } from './SectionCircleLoader'

const Container = styled(animated.div)`
  display: flex;
  justify-content: center;
`

export const ComponentLoading = () => {
  return (
    <Container>
      <SectionCircleLoader />
    </Container>
  )
}
